/**
 * Box de fundamentação metodológica + citações setoriais + disclaimer.
 */
export interface MethodologyCitationsProps {
  norms: string[]            // ex: ["NIST CSF 2.0 (2024)", "ISO/IEC 27001:2022"]
  sectorCitations?: string[]  // ex: ["Resolução BCB 4.658/2018"]
  disclaimer?: string
}

export default function MethodologyCitations({
  norms,
  sectorCitations = [],
  disclaimer,
}: MethodologyCitationsProps) {
  return (
    <section className="text-xs text-slate-400 space-y-2 bg-slate-900/30 border border-slate-800 rounded-xl p-4">
      <p className="font-bold text-slate-300">Fundamentação metodológica</p>
      <p>{norms.join(' · ')}</p>
      {sectorCitations.length > 0 && (
        <>
          <p className="font-bold text-slate-300 mt-2">Normas específicas do setor</p>
          <p>{sectorCitations.join(' · ')}</p>
        </>
      )}
      {disclaimer && (
        <p className="italic text-slate-500 mt-3 pt-3 border-t border-slate-800">{disclaimer}</p>
      )}
    </section>
  )
}
